// extracted by mini-css-extract-plugin
export var copyable = "_o-1";
export var explainable = "_o-0";
export var negative = "_o-2";
export var positive = "_o-3";